import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UtilsService } from '../utils/utils.service';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class RingcentralService {
	constructor(private http: HttpClient, private utils: UtilsService) {}

	uploadFile(formData) {
		const url = `${environment.api}lead/upload_files`;
		return this.http.post(url, formData);
	}

	getUserExtension(payload) {
		const url = `${environment.api}ringcentral/get_extension_id`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}
}
